import { createClient as createWSClient } from 'graphql-ws'
import { CONDUIT } from './endpoints'

async function supportsGraphQLTransportWS (): Promise<boolean> {
  if (!navigator.onLine) {
    // Assume websockets are supported if we're currently offline
    // neither will work anyway, so just use the better protocol which may recover better
    return true
  }

  return Promise.race([
    new Promise<boolean>((resolve) => {
      setTimeout(() => resolve(false), 10000)
    }),
    new Promise<boolean>((resolve) => {
      const client = createWSClient({
        url: CONDUIT,
        retryAttempts: 0,
        lazy: false,
        connectionAckWaitTimeout: 10000,
        on: {
          closed: () => resolve(false),
          connected: () => {
            resolve(true) // connected = supported
            client.dispose() // dispose after check
          }
        }
      })
    })
  ])
}

let websocketsSupported = true

export function areWebsocketsSupported () { return websocketsSupported }
export const whileTestingWebsocketSupport = supportsGraphQLTransportWS().then(isSupported => { websocketsSupported = isSupported })
